var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
export var useMediaQuery = function (query) {
    var _a = __read(useState(function () { return window.matchMedia(query).matches; }), 2), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        var match = window.matchMedia(query);
        function listener(e) {
            setMatches(e.matches);
        }
        match.addEventListener("change", listener);
        return function () {
            match.removeEventListener("change", listener);
        };
    }, [query]);
    return matches;
};
export function useMediaQueries(queries, defaultValue) {
    var _a = __read(useState(defaultValue), 2), result = _a[0], setResult = _a[1];
    useEffect(function () {
        var matches = queries.map(function (_a) {
            var _b = __read(_a, 2), query = _b[0], value = _b[1];
            var match = window.matchMedia(query);
            if (match.matches) {
                setResult(value);
            }
            function listener(e) {
                if (e.matches) {
                    setResult(value);
                }
            }
            match.addEventListener("change", listener);
            return [match, listener];
        });
        return function () {
            matches.forEach(function (_a) {
                var _b = __read(_a, 2), match = _b[0], listener = _b[1];
                return match.removeEventListener("change", listener);
            });
        };
    }, [queries]);
    return result;
}
